// extracted by mini-css-extract-plugin
export var attachmentContainer = "_s9-0";
export var fileList = "_s9-2";
export var removeFileButton = "_s9-1";